<div class="receipt-page" *ngIf="loading">
  <div class="state-card">
    <div class="spinner"></div>
    <p>Loading receipt…</p>
  </div>
</div>

<div class="receipt-page" *ngIf="!loading && !order">
  <div class="state-card">
    <p class="state-icon">⚠</p>
    <h2>Receipt Not Found</h2>
  </div>
</div>

<div class="receipt-page" *ngIf="!loading && order">

  <div id="receipt" class="receipt">

    <!-- Company -->
    <div class="center brand">
      <h2>SUPER BANGLADESH</h2>
      <p>Building a Sustainable Future</p>
      <p>www.superbangladesh.com</p>
      <p>support&#64;superbangladesh.com</p>
      <p>☎ +880 1756-442133</p>
      <p>Dhaka, Bangladesh</p>
    </div>

    <div class="rule"></div>

    <!-- Invoice -->
    <table class="info">

      <tr>
        <td>Invoice</td>
        <td class="val">{{ order.invoiceNumber || ('INV-' + order.id) }}</td>
      </tr>

      <tr>
        <td>Order ID</td>
        <td class="val">#{{ order.id }}</td>
      </tr>

      <tr>
        <td>Date</td>
        <td class="val">{{ order.createdAt | date:'dd MMM yyyy hh:mm a' }}</td>
      </tr>

      <tr>
        <td>Customer</td>
        <td class="val">{{ order.name }}</td>
      </tr>

      <tr>
        <td>Phone</td>
        <td class="val">{{ order.phone }}</td>
      </tr>

      <tr>
        <td>Payment</td>
        <td class="val">{{ order.paymentMethod }}</td>
      </tr>

      <tr>
        <td>Status</td>
        <td class="val">{{ order.status }}</td>
      </tr>

    </table>

    <div class="rule"></div>

    <!-- Products -->
    <table class="items">

    <thead>
  <tr>
    <th>#</th>
    <th>Item</th>
    <th>SKU</th>
    <th class="align-right">Qty</th>
    <th class="align-right">Price</th>
    <th class="align-right">Total</th>
  </tr>
</thead>

      <tbody>
  <tr *ngFor="let item of (order.items || []); let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ item.productName }}</td>
    <td>{{ item.productSku || '—' }}</td>
    <td class="align-right">{{ item.quantity | bnNumber }}</td>
    <td class="align-right">{{ item.price | bnNumber }}</td>
    <td class="align-right">{{ (item.price * item.quantity) | bnNumber }}</td>
  </tr>
</tbody>

    </table>

    <div class="rule"></div>

    <!-- Total -->
    <table class="summary">

      <tr>
        <td>Total Amount</td>
        <td class="align-right">{{ order.totalAmount | bnNumber:'৳ ' }}</td>
      </tr>

      <tr class="grand">
        <td>Paid</td>
        <td class="align-right">{{ (order.paidAmount || order.totalAmount) | bnNumber:'৳ ' }}</td>
      </tr>

    </table>

    <div class="rule rule--double"></div>

    <div class="center thanks">
      <strong>Thank You</strong>
      <p>Please Visit Again</p>
      <p class="powered">Powered by Super Bangladesh</p>
    </div>

  </div>

  <div class="action-buttons">

    <button class="print-btn" (click)="printReceipt()">
      🖨 Print Receipt
    </button>

    <button class="download-btn" (click)="downloadPdf()">
      ⬇ Download PDF
    </button>

  </div>

</div>
